import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link, Switch } from 'react-router-dom'
import hom from 'src/assets/sidebar_images/home.svg'
import dummy from 'src/assets/sidebar_images/vector4.svg'
import { Tooltip, Zoom } from '@mui/material'
import { useSelector } from 'react-redux'
import { COLORS } from 'src/utils/Themes/colors'
import RiskReports from 'src/components/RiskReports'
import Profile from 'src/components/Individual/profile/Profile'
import PolicyDashboardTabs from 'src/components/Individual/PolicyDashboardTabs'
import CeoView from 'src/components/ceo/CeoView'
import { CLIENT_TYPE } from 'src/utils/constants/common'
import { isCorporateAdmin, isCorporateLeader } from 'src/utils/commonMethods'
import QRReport from 'src/components/CustomerQRReport/QRReport'
import OtpVerification from 'src/components/CustomerQRReport/OtpVerfication/OtpVerification'
import { makeStyles } from '@material-ui/core/styles'
import RouteMiddleware from 'src/components/common/RouteMiddleware'
import BuyPolicyLayout from 'src/components/BuyPolicy/layout/BuyPolicyLayout'
import Personalize from '../Personalize/Personalize'
import EmployeeManagement from 'src/components/ceo/EmployeeManagement/EmployeeManagement'
import ViewEmployee from 'src/components/ceo/EmployeeManagement/ViewEmployee'
import CdBalanceView from 'src/components/ceo/CDBalance/CdBalanceView'
import CdAccountLinkedPolicies from 'src/components/ceo/CDBalance/CdAccountLinkedPolicies'
import { HOME } from 'src/utils/constants/Individual'

const Sidebar = (props) => {
  const classes = useStyles()
  const userInfo = useSelector((state) => state?.userInfo)
  const [activeIndex, setActiveIndex] = useState(props?.option)

  useEffect(() => {
    if (isCorporateLeader(userInfo?.userInfo?.userData?.roles)) {
      const urlLast = window.location.href?.split('/')
      const temp = urlLast[urlLast?.length - 1]
      temp === HOME ? setActiveIndex(1) : setActiveIndex(0)
    }
  }, [
    userInfo?.userInfo?.userData?.roles?.length,
    userInfo?.userInfo?.userData?.roles,
  ])

  const SidebarItems = [
    {
      id: hom,
      tooltipText: 'Dashboard',
      route: '/individual/dashboard',
    },
  ]
  const SidebarItemsLeader = [
    {
      id: hom,
      tooltipText: 'Leadership Dashboard',
      route: '/individual/dashboard',
    },
    {
      id: dummy,
      tooltipText: 'Policies',
      route: '/individual/dashboard/home',
    },
  ]

  let FinalSidebarItems = isCorporateLeader(userInfo?.userInfo?.userData?.roles)
    ? SidebarItemsLeader
    : SidebarItems

  const getDashboardComponent = () => {
    const roles = userInfo?.userInfo?.userData?.roles

    if (isCorporateLeader(roles)) {
      return <RiskReports />
    }

    if (isCorporateAdmin(roles)) {
      return (
        <CeoView
          clientId={userInfo?.userInfo?.userData?.clientId}
          clientType={CLIENT_TYPE?.CORPORATE}
        />
      )
    }

    return (
      <div className={classes.mainGridContainer}>
        <div className={classes.gridContainer}>
          <PolicyDashboardTabs />
        </div>
        <div className={classes.statsContainer}>
          {/* <RiskScore />*/}
          {/* <OverAllSuggestions />*/}
          <Personalize />
        </div>
      </div>
    )
  }

  return (
    <>
      <SidebarParent>
        {FinalSidebarItems?.map((item, index) => {
          return (
            <SidebarEach key={`nav-${item?.id}`} active={index === activeIndex}>
              <Tooltip
                TransitionComponent={Zoom}
                placement='right'
                title={item?.tooltipText}
                arrow
              >
                <Link to={item?.route} onClick={() => setActiveIndex(index)}>
                  <SidebarItem key={item?.id} id={`navP-${index}`}>
                    <img src={item?.id} alt={'img'} id={`nav-${index}`} />
                  </SidebarItem>
                </Link>
              </Tooltip>
            </SidebarEach>
          )
        })}
      </SidebarParent>
      <Switch>
        <RouteMiddleware
          title={'Profile Page'}
          exact
          path='/individual/dashboard/profile'
          component={Profile}
        />

        <RouteMiddleware
          title={'Individual Leadership Dashboard'}
          path='/individual/dashboard'
          exact
        >
          {getDashboardComponent()}
        </RouteMiddleware>

        {/* {isCorporateLeader(userInfo.userInfo.userData.roles) ? (*/}
        {/*  <RouteMiddleware*/}
        {/*    title={'Individual Leadership Dashboard'}*/}
        {/*    path='/individual/dashboard'*/}
        {/*    exact*/}
        {/*    component={RiskReports}*/}
        {/*  />*/}
        {/* ) : (*/}
        {/*  <RouteMiddleware title={'Individual Dashboard'} exact path='/individual/dashboard'>*/}
        {/*    <div className={classes.mainGridContainer}>*/}
        {/*      <div className={classes.gridContainer}>*/}
        {/*        <PolicyDashboardTabs />*/}
        {/*      </div>*/}
        {/*      <div className={classes.statsContainer}>*/}
        {/*        <Personalize />*/}
        {/*        /!*<RiskScore />*!/*/}
        {/*        /!*<OverAllSuggestions />*!/*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </RouteMiddleware>*/}
        {/* )} future development*/}

        {isCorporateLeader(userInfo?.userInfo?.userData?.roles) ||
        isCorporateAdmin(userInfo?.userInfo?.userData?.roles) ? (
          <RouteMiddleware
            title={'Individual Admin View'}
            exact
            path='/individual/dashboard/home'
          >
            <div className={classes.mainGridContainer}>
              <div className={classes.gridContainer}>
                <PolicyDashboardTabs />
              </div>
              <div className={classes.statsContainer}>
                {/* <RiskScore />*/}
                {/* <OverAllSuggestions />*/}
                <Personalize />
              </div>
            </div>
          </RouteMiddleware>
        ) : null}

        <RouteMiddleware
          title={'CEO View'}
          exact
          path='/individual/dashboard/company'
        >
          <CeoView
            clientId={userInfo?.userInfo?.userData?.clientId}
            clientType={CLIENT_TYPE?.CORPORATE}
          />
        </RouteMiddleware>

        <RouteMiddleware
          title={'Employee Management'}
          exact
          path='/individual/dashboard/company/employeeManagement'
        >
          <EmployeeManagement
            clientId={userInfo?.userInfo?.userData?.clientId}
            clientType={CLIENT_TYPE?.CORPORATE}
            isCompanyPolicy={true}
          />
        </RouteMiddleware>

        <RouteMiddleware
          title={'Employee View'}
          exact
          path='/individual/dashboard/company/employeeManagement/viewEmployee/:id'
          component={ViewEmployee}
        />

        <RouteMiddleware
          title={'Individual Risk Report'}
          path='/individual/dashboard/riskReport'
          exact
          component={RiskReports}
        />
        <RouteMiddleware
          title={'QR Scanner'}
          path='/individual/dashboard/qrReport/'
          exact
          component={QRReport}
        />
        <RouteMiddleware
          title={'Buy Policy'}
          path='/individual/dashboard/buyPolicy/'
        >
          <BuyPolicyLayout isHeaderHidden={!!userInfo} />
        </RouteMiddleware>
        <RouteMiddleware
          title={'Resend OTP Page'}
          path='/resend-otp'
          exact
          component={OtpVerification}
        />
        <RouteMiddleware
          title={'CD Balance'}
          path='/individual/dashboard/cdBalanceView/'
          exact
          component={CdBalanceView}
        />
        <RouteMiddleware
          title={'CD Balance View'}
          path='/individual/dashboard/CdAccountLinkedPolicies/:id'
          exact
          component={CdAccountLinkedPolicies}
        />
      </Switch>
    </>
  )
}

export default Sidebar

const useStyles = makeStyles({
  gridContainer: {
    width: '75%',
    display: 'flex',
    flexDirection: 'column',
    '@media only screen and (max-width:768px)': {
      width: '100%',
    },
  },
  statsContainer: {
    width: '25%',
    display: 'flex',
    flexDirection: 'column',
    '@media only screen and (max-width:768px)': {
      width: '100%',
    },
  },
  mainGridContainer: {
    display: 'flex',
    width: '100%',
    '@media only screen and (max-width:768px)': {
      flexDirection: 'column',
    },
  },
})

const SidebarEach = styled.div`
  display: flex;
  width: 45px;
  height: 47px;
  justify-content: center;
  align-items: center;
  background: ${(props) => (props.active ? COLORS.MEDIUM_GREY : '')};
  border-left: ${(props) =>
    props.active ? `3px solid ${COLORS.MEDIUM_ORANGE}` : ''};
`

const SidebarParent = styled.div`
  background: ${COLORS.WHITE};
  width: 47px;
  height: 100vh;
  display: none;
`
const SidebarItem = styled.div`
  text-align: center;

  img {
    width: 70%;
  }

  &:hover {
    cursor: pointer;
  }

  &:hover:not(:first-child) {
    background: ${COLORS.LIGHT_GREY};
  }
`
